/**
 * `user_key` da campanha da AdvancedBR: SHA-256 em hexadecimal do e-mail sem
 * espaços nas pontas e em minúsculas. O app calcula o mesmo valor e o envia no
 * `/redirect`, e o marketing cruza os dois pelo GA4. Conferência:
 * `jean@voopter.com.br` →
 * `2a044ce88720a8134aa0718454c8938f0d3a895b310832ca32f6aa48ea7ff4fd`.
 *
 * Devolve `null` quando o navegador não tem `crypto.subtle` (contexto não
 * seguro ou navegador antigo): quem chama segue sem o `user_key`.
 */
export async function getUserKey(email: string): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) return null;

  try {
    const digest = await subtle.digest(
      "SHA-256",
      new TextEncoder().encode(email.trim().toLowerCase()),
    );

    return Array.from(new Uint8Array(digest), (byte) =>
      byte.toString(16).padStart(2, "0"),
    ).join("");
  } catch (error) {
    console.warn("⚠️ user_key indisponível:", error);
    return null;
  }
}
